import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import routes from '../routes'
import { SIZES } from '../styles/theme'
import loginBtn from '../images/login-button.png'

const Page = styled.div`
  #enter-btn {
    position: fixed;
    top: 36%;
    bottom: 40%;
    left: 31%;
    right: 31%;
    color: #ffffff;
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 20px;
    font-style: italic;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* div {
      line-height: 32px;
    } */
  }
  .click-login-text {
    margin-top: -12px;
    font-weight: 600;
  }

  #reg-btn {
    position: fixed;
    top: 58%;
    bottom: 58%;
    left: 31%;
    right: 31%;
    color: #ffffff;
    font-weight: 400;
    letter-spacing: 1px;
    font-size: 16px;
    font-style: italic;
    display: flex;
    flex-direction: column;
    align-items: center;
    div {
      line-height: 32px;
    }
    .click-login-text {
      margin-top: 20px;
      font-weight: 600;
    }
  }

  ${SIZES.mobile} {
    #enter-btn {
      top: 22%;
      bottom: 58%;
      left: 50%;
      right: 0%;
      transform: translateX(-50%);
    }

    .click-login-text {
      font-size: 16px;
    }

    #reg-btn {
      top: 39%;
      bottom: 58%;
      left: -1%;
      right: -1%;
      div {
        line-height: 32px;
      }
    }

    .click-reg-text {
      margin-top: 25px;
      font-size: 12px;
    }
  }
`

export default function WelcomePage() {
  return (
    <Page>
      <Link id="enter-btn" to={routes.lobby} className="btn">
        <img src={loginBtn} width="125px" alt="login form button" />
        <div className="click-login-text">Click To Login</div>
      </Link>

      <Link id="reg-btn" to={routes.registration} className="btn">
        <div className="click-reg-text">Don't have an account? Click here to register</div>
      </Link>
    </Page>
  )
}
